module.exports = __webpack_public_path__ + "static/img/fang.1ee44b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fang.png
// module id = 75l0
// module chunks = 1